<template>
  <div class="account">
    <!-- <div class="accounttop">
      <div class="accountname">{{$t('account.uselists')}}</div>
    </div> -->
    <div class="search">
      <el-select
        v-model="search.role"
        clearable
        @change="getAccountList(true)"
        :placeholder="$t('account.role')"
        popper-class="select-search"
      >
      <el-option v-for="(value,key) in roleOptions" :key="key" :value="key" :label="value.name"></el-option>
      </el-select>
      <el-select
        v-model="search.active"
        clearable
        @change="getAccountList(true)"
        :placeholder="$t('account.activeStatus')"
        popper-class="select-search"
      >
        <el-option
          v-for="(value,key) in searchOptions.activeStatus"
          :key="key"
          :value="key"
          :label="value.label"
        ></el-option>
      </el-select>
      <el-select
        v-model="search.enable"
        clearable
        @change="getAccountList(true)"
        :placeholder="$t('account.accountStatus')"
        popper-class="select-search"
      >
        <el-option
          v-for="(value,key) in searchOptions.accountStatus"
          :key="key"
          :value="key"
          :label="value.label"
        ></el-option>
      </el-select>
      <el-select
        v-model="search.groupid"
        clearable
        @change="getAccountList(true)"
        :placeholder="$t('account.accountGroup')"
        popper-class="select-search"
      >
        <el-option
          v-for="(item,index) in searchOptions.accountGroup"
          :key="index"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <el-input
        v-model.trim="search.usr"
        @keyup.enter.native="getAccountList(true)"
        :placeholder="this.$t('account.accountName')"
        clearable
      ></el-input>
      <button class="button-solid button" @click="getAccountList(true)"><i class="el-icon-search"></i></button>
      <button
        class="button-solid button button-create"
        @click="creatcount"
      ><i class="el-icon-circle-plus-outline el-icon--left"></i>{{$t('account.createAccount')}}</button>
    </div>
    <div class="sections">
      <!-- <div class="title">{{$t('account.accountList')}}</div> -->
      <div class="table">
        <el-table
          :data="accountList"
          border
          stripe
          height="100%"
          :row-style="{height:0}"
          :cell-style="{padding:0}"
          :header-cell-style="{background:'#F2F5F7',color:'#606266'}"
          v-loading="loadingAccount"
          element-loading-spinner="el-icon-loading"
        >
        <!-- :empty-text="$t('message.nodata')" -->
          <el-table-column fixed :show-overflow-tooltip="true" min-width="120px;" :label="$t('account.accountName')">
            <template slot-scope="scope">
              <span class="redirect" @click="enterAccount(scope.row)">{{scope.row.usr}}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" min-width="100px;" :label="$t('account.nickname')">
            <template slot-scope="scope">
              <span 
              :title="scope.row.qname||'--'"
              >{{scope.row.qname||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="role" :show-overflow-tooltip="true" min-width="150px;" :label="$t('account.role')"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" min-width="120px;" :label="$t('account.activeStatus')">
            <template slot-scope="scope">
              <span :class="scope.row.active.class">{{scope.row.active.label}}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" min-width="130px;" :label="$t('account.accountStatus')">
            <template slot-scope="scope">
              <span :class="scope.row.enable.class">{{scope.row.enable.label}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="collectors"
            min-width="110px;"
            :show-overflow-tooltip="true"
            :label="$t('account.dataloggerNum')"
          ></el-table-column>
          <el-table-column
            prop="devices"
            min-width="90px;"
            :show-overflow-tooltip="true"
            :label="$t('account.deviceNum')"
          ></el-table-column>
          <el-table-column
            min-width="130px;"
            :show-overflow-tooltip="true"
            :label="$t('account.mobile')"
          >
          <template slot-scope="scope">
              <span 
              :title="scope.row.mobile||'--'"
              >{{scope.row.mobile||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column 
            min-width="130px;"
            :label="$t('account.email')"
            :show-overflow-tooltip="true"
          >
          <template slot-scope="scope">
              <span 
              :title="scope.row.email||'--'"
              >{{scope.row.email||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            min-width="100px;"
            :show-overflow-tooltip="true"
            :label="$t('account.nickname')"
          >
           <template slot-scope="scope">
              <span 
              :title="scope.row.qname||'--'"
              >{{scope.row.qname||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            min-width="110px;"
            :show-overflow-tooltip="true"
            :label="$t('account.accountGroup')"
          >
            <template slot-scope="scope">
              <span 
              :title="scope.row.group||'--'"
              >{{scope.row.group||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="gts"
            min-width="150px;"
            :show-overflow-tooltip="true"
            :label="$t('account.createTime')"
          ></el-table-column>
          <el-table-column
            min-width="130px;"
            :show-overflow-tooltip="true"
            :label="$t('account.lastLogin')"
          >
          <template slot-scope="scope">
              <span 
              :title="scope.row.lastLoginTs||'--'"
              >{{scope.row.lastLoginTs||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('account.operate')" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="operation"
                :title="$t('account.Edit')"
                @click="editcount(scope.row)"
              >
                <i class="iconfont icon-edit1"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                v-show="scope.row.enable.class=='active'"
                :title="$t('account.disable')"
                @click="disablecount(scope.row)"
              >
                <i class="iconfont icon-jinyong"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                v-show="scope.row.enable.class=='inactive'"
                :title="$t('account.enable')"
                @click="disablecount(scope.row)"
              >
                <i class="iconfont icon-qiyong"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('account.group')"
                @click="groupcount(scope.row)"
              >
                <i class="iconfont icon-fenzu1"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('account.resetPwd')"
                @click="resetpwd(scope.row)"
              >
                <i class="iconfont icon-mima"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('account.Delete')"
                @click="detelegroup(scope.row)"
              >
                <i class="iconfont icon-delete"></i>
              </el-button>
            </template>
          </el-table-column>
          <div v-show="emptyText" slot="empty"><img src="@/assets/img/empty_text.png"/>
            <div style="line-height: 32px">{{$t('account.nodata')}}</div>
            <p><el-button size="small" type="primary" @click="creatcount">{{$t('account.createAccount')}}</el-button></p>
          </div>
        </el-table>
      </div>
      <div class="tablebottom">
        <el-pagination
          class="pagination"
          v-if="paginationControl"
          background
          @size-change="getAccountList(true)"
          @current-change="()=>getAccountList()"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[10,15,20,30,50]"
          :page-size.sync="pagination.pagesize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
    </div>
    <!-- 创建新账号 -->
    <account-dialog
      :title="$t('account.createAccount')"
      :visible.sync="showCreatnewcountDialog"
      width="60vh"
      v-if="showCreatnewcountDialog"
    >
      <el-form ref="creatForm" :model="form" class="chuangjian grid"
      slot="content" :rules="creatRules">
        <el-form-item :label="$t('account.role1')">
          <el-select v-model="form.role" :placeholder="$t('account.selectUserType')">
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
            <!-- 普通用户0 -->
            <el-option :label="$t('account.powerStationOwner')" value="0"></el-option>
            <!-- 经销商2 -->
            <el-option :label="$t('account.manageAccount')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('account.accountName1')" prop="name">
          <el-input
            v-model.trim="form.name"
            clearable
            :placeholder="$t('account.accountName')"
            @clear="Bytecheck"
            @keyup.native="UserByte"
            @keyup.enter.native="$refs.creatqname.focus()"
          >
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
          <div class="inputlo">
            <div :class="isError?'input_spans':'sucess'" v-show="!Byte">
              <span>{{usrtip}}</span>
            </div>
            <div class="input_span" v-show="Byte">
              <span
                style="font-size: 12px;font-weight: bold;"
              >{{$t('signup.Byte_1')}}</span>
              <span
                style="margin-left:2px;font-size:12px;font-weight:bold;color:#f00;"
              >{{Bytes}}</span>
              <span
                style="font-size: 12px;font-weight: bold;margin-left: 2px;"
              >{{$t('signup.Byte_2')}}</span>
            </div>
            <!-- <span>{{usrtip}}</span> -->
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.nickname1')" prop="qname">
          <el-input
            v-model.trim="form.qname"
            :placeholder="$t('account.nickname')"
            clearable
            ref="creatqname"
            @keyup.enter.native="$refs.creatpwd.focus()"
          >
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.password1')" prop="pwd">
          <el-input
            v-model.trim="form.pwd"
            :placeholder="$t('account.password')"
            clearable
            type="text"
            class="password"
            ref="creatpwd"
            @clear="pwdcheck"
            @input.native="Passwordlevel"
            @keyup.enter.native="$refs.creatconfPwd.focus()"
          >
            <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
          </el-input>
          <div class="inputlo">
            <div :class="passpwdError?'pwd_span':'sucess'" v-show="!strength">
              <span>{{pwdtip}}</span>
            </div>
            <div class="input_span" v-show="strength">
              <span
                style="font-size: 12px;font-weight: bold;"
              >{{$t('signup.qiangdu')}}</span>
              <span class="juxing" ref="Passwordlevel"></span>
              <span
                style="font-size: 12px;font-weight: bold;margin-left: 5px;"
              >{{count}}</span>
            </div>
            <!-- <span>{{usrtip}}</span> -->
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.confirmpassword1')" prop="confPwd">
          <el-input
            v-model.trim="form.confPwd"
            :placeholder="$t('account.confirmpassword')"
            clearable
            type="text"
            class="password"
            ref="creatconfPwd"
            @keyup.enter.native="$refs.createmail.focus()"
          >
            <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
          </el-input>
          <div class="inputlo">
            <div :class="confpwdError?'confpwd_span':'sucess'">
              <span>{{confpwdtip}}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.mobile1')" prop="mobile">
          <el-input
            v-model.trim="form.mobile"
            :placeholder="$t('account.mobile')"
            clearable
            type="text"
            ref="createmail"
            @keyup.enter.native="$refs.creatmobile.focus()"
          >
            <!-- <img slot="prefix" src="@/assets/img/shouji.png" style="width:13px;height:22px;" /> -->
          </el-input>
          <div class="inputlo">
            <div :class="phoneError?'phone_span':'sucess'">
              <span>{{phonetip}}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.email1')" prop="email">
          <el-input
            v-model.trim="form.email"
            :placeholder="$t('account.email')"
            clearable
            @clear="emailcheck"
            ref="creatmobile"
            @keyup.enter.native="creatnewcount"
          >
            <!-- <img slot="prefix" src="@/assets/img/youxiang.png" style="width:19px;height:14px;" /> -->
          </el-input>
          <div class="inputlo">
            <div :class="emailError?'email_span':'sucess'">
              <span>{{emailtip}}</span>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
        <button class="button-solid" @click="creatnewcount">{{$t('account.submit')}}</button>
      </div>
    </account-dialog>
    <!--编辑用户 -->
    <account-dialog
      :title="$t('account.editUser')"
      :visible.sync="showEditcountDialog"
      :width="'450px'"
      v-if="showEditcountDialog"
    >
      <el-form
        ref="editForm"
        :model="usrDatas"
        :rules="editRules"
        slot="content"
        class="bianji grid"
        v-loading="loadingeditcount"
        element-loading-spinner="el-icon-loading"
      >
        <el-form-item :label="$t('account.role1')">
          <el-input :value="usrDatas.role" auto-complete="off" disabled>
            <!-- <img slot="prefix" src="@/assets/img/usr_gl.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.accountName1')">
          <el-input v-model="usrDatas.usr" auto-complete="off" disabled>
            <!-- <img slot="prefix" src="@/assets/img/nicheng.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.nickname1')">
          <el-input clearable v-model="usrDatas.qname" auto-complete="off">
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.mobile1')" prop="mobile">
          <el-input clearable type="text" v-model="usrDatas.mobile">
            <!-- <img slot="prefix" src="@/assets/img/shouji.png" style="width:13px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.email1')" prop="email">
          <el-input clearable v-model="usrDatas.email" auto-complete="off">
            <!-- <img slot="prefix" src="@/assets/img/youxiang.png" style="width:19px;height:14px;" /> -->
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
        <button class="button-solid" @click="editoldcount">{{$t('account.confirm')}}</button>
      </div>
    </account-dialog>
    <!-- 禁用/启用用户 去掉弹框的heard不加title=""和footer noFooter -->
    <account-dialog
      :visible.sync="showdisablecountDialog"
      :width="'450px'"
      v-if="showdisablecountDialog"
      noFooter
    >
      <div
        v-if="this.params.enable.class =='active'?true:false"
        slot="content"
        class="content_tishi"
      >
        <div class="tital">
        <i class="iconfont icon-gantanhao"></i>
        <span class="contentdelete">{{$t('account.confirmDisable')}}</span>
        </div>
        <!-- <div class="disablecontent">{{$t('account.confirmDisable')}}</div> -->
        <div class="disabledescr">{{$t('account.afterDisable')}}</div>
      <div class="deletfotter">
        <button class="button-solid" @click="disableoldcount">{{$t('account.confirm')}}</button>
        <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
      </div>
      </div>
      <div
        v-if="this.params.enable.class =='inactive'?true:false"
        slot="content"
        class="content_tishi"
      >
        <div class="tital">
        <i class="iconfont icon-gantanhao"></i>
        <div class="contentdelete">{{$t('account.confirmEnable')}}</div>
        </div>
        <!-- <div class="disablecontent">{{$t('account.confirmEnable')}}</div> -->
        <div class="disabledescr">{{$t('account.afterEnable')}}</div>
        <div class="deletfotter">
        <button class="button-solid" @click="disableoldcount">{{$t('account.confirm')}}</button>
        <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
      </div>
      </div>
      <!-- <div class="deletfotter">
        <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button>
        <button class="button-solid" @click="disableoldcount">{{$t('account.confirm')}}</button>
      </div> -->
    </account-dialog>
    <!-- 分组用户 -->
    <account-dialog
      :title="$t('account.group')"
      :visible.sync="showGroupcountDialog"
      :width="'50vh'"
      v-if="showGroupcountDialog"
    >
      <el-form slot="content" class="bianji grid" ref="groupform" :model="groupcountcontent" :rules="groupRules">
        <el-form-item :label="$t('account.accountName1')">
          <el-input :value="groupcountcontent.usr" auto-complete="off" disabled>
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.group1')" prop="id">
          <el-select v-model="groupcountcontent.id" :placeholder="$t('account.chooseGroup')">
            <!-- <img slot="prefix" src="@/assets/img/fenzu.png" style="width:18px;height:22px;" /> -->
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
        <button class="button-solid" @click="addgroupcount">{{$t('account.confirm')}}</button>
      </div>
    </account-dialog>
    <!-- 重置密码 -->
    <account-dialog
      :title="$t('account.resetPwd')"
      :visible.sync="showResetpwdDialog"
      :width="'500px'"
      v-if="showResetpwdDialog"
    >
      <el-form slot="content" class="chongzhi grid" ref="resetform" :model="resetform" :rules="resetRules">
        <el-form-item :label="$t('account.accountName1')" prop="usr">
          <el-input :value="resetform.usr" auto-complete="off" disabled>
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.newPwd1')" prop="newpwd">
          <el-input
            v-model.trim="resetform.newpwd"
            :placeholder="$t('account.newPwd')"
            type="text"
            class="password"
            clearable
            @clear="pwdcheck"
            @input.native="NewPasswordlevel"
            @keyup.enter.native="$refs.resetconfPwd.focus()"
          >
            <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
          </el-input>
          <div class="inputlo">
            <div :class="passpwdError?'pwd_span':'sucess'" v-show="!strength">
              <span>{{pwdtip}}</span>
            </div>
            <div class="input_span" v-show="strength">
              <span
                style="font-size: 12px;font-weight: bold;"
              >{{$t('signup.qiangdu')}}</span>
              <span class="juxing" ref="NewPasswordlevel"></span>
              <span
                style="font-size: 12px;font-weight: bold;margin-left: 5px;"
              >{{count}}</span>
            </div>
            <!-- <span>{{usrtip}}</span> -->
          </div>
        </el-form-item>
        <el-form-item :label="$t('account.confirmpassword1')" prop="confPwd">
          <el-input
            v-model.trim="resetform.confPwd"
            :placeholder="$t('account.confirmpassword')"
            type="text"
            class="password"
            clearable
            ref="resetconfPwd"
            @keyup.enter.native="resetpwdold"
          >
            <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
          </el-input>
          <div class="inputlo">
            <div :class="confpwdError?'confpwd_span':'sucess'">
              <span>{{confpwdtip}}</span>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <button class="button-solid" @click="resetpwdold">{{$t('account.confirm')}}</button>
        <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
      </div>
    </account-dialog>
    <!-- 删除用户 去掉弹框的heard不加title=""和footer noFooter -->
    <account-dialog
      :visible.sync="showDeletecountDialog"
      :width="'450px'"
      v-if="showDeletecountDialog"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="tital">
        <i class="iconfont icon-gantanhao"></i>
        <span class="contentdelete">{{$t('account.confirmDelete')}}</span>
        </div>
        <div class="disabledescr">{{$t('account.notRecovered')}}</div>
        <!-- {{$t('account.confirmDelete')}}</div> -->
        <div class="deletfotter">
          <button class="button-solid" @click="deleteoldcount">{{$t('account.confirm')}}</button>
          <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button>
        </div>
      </div>
    </account-dialog>
  </div>
</template>
<script>
import accountDialog from "@/components/dialog";
import encryption from "@/assets/js/encryption";
import cookie from "@/assets/js/cookie";
export default {
  components: {
    accountDialog
  },
  data() {
    var validateusr = (rule, value, callback) => {
      var ref = /^([a-zA-Z0-9_\u4e00-\u9fa5]{2,32})$/;
      if (!value) {
        callback(new Error(""));
        this.usrtip = this.$t("message.uname_is_required");
        this.isError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.usrtip = this.$t("signup.usrformat");
        this.isError = true;
      } else {
        callback();
      }
    };
    var validatepwd = (rule, value, callback) => {
      var ref = /^[\w]{6,32}$/;
      if (!value) {
        callback(new Error(""));
        this.pwdtip = this.$t("message.pwd_is_required");
        this.passpwdError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.pwdtip = this.$t("signup.pwdformat");
        this.passpwdError = true;
      } else {
        callback();
      }
    };
    //新建账号的密码确认
    var validateconfPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdAgain");
        this.confpwdError = true;
      } else if (value !== this.form.pwd) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdNotsame");
        this.confpwdError = true;
      } else {
        this.confpwdtip = "";
        callback();
      }
    };
    //重置密码的密码确认
    var validateconfNewpwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdAgain");
        this.confpwdError = true;
      } else if (value !== this.resetform.newpwd) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdNotsame");
        this.confpwdError = true;
      } else {
        this.confpwdtip = "";
        callback();
      }
    };
    var validateemail = (rule, value, callback) => {
      var ref = /^(?=\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$).{0,64}$/;
      if (!value) {
        callback(new Error(""));
        this.emailtip = this.$t("message.email_is_required");
        this.emailError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.emailtip = this.$t("message.email_info");
        this.emailError = true;
      } else {
        this.emailtip = "";
        callback();
      }
    };
    var validatephone = (rule, value, callback) => {
      var ref = /^\d{6,32}$/;
      if (!value) {
        callback(new Error(""));
        this.phonetip = this.$t("message.mobile_is_required");
        this.phoneError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.phonetip = this.$t("signup.mobileformat");
        this.phoneError = true;
      } else {
        this.phonetip = " ";
        callback();
      }
    };
    return {
      emptyText:false,//默认不显示无数据
      personActive:false,
      personActives:'',
      personInactive:false,
      personInactives:'',
      paginationControl:false,//分页默认为没有
      confpwdError: false,
      isError: false,
      emailError: false,
      passpwdError: false,
      phoneError: false,
      Bytes: "",
      count: "",
      Byte: false,
      usrtip: '',
      pwdtip: '',
      emailtip: '',
      phonetip: '',
      confpwdtip: '',
      // usrtip: this.$t("signup.usr"),
      // pwdtip: this.$t("signup.pwd"),
      // emailtip: this.$t("signup.email_form"),
      // phonetip: this.$t("signup.phone_form"),
      // confpwdtip: this.$t("signup.confirm_pl"),
      strength: false,
      showCreatnewcountDialog: false, //创建账号弹窗
      showEditcountDialog: false, //打开编辑用户信息弹框
      showGroupcountDialog: false, //打开分组弹框
      showdisablecountDialog: false, //打开禁用弹框
      showResetpwdDialog: false, //打开重置密码弹框
      showDeletecountDialog: false, //打开删除账号弹框
      search: {
        role: null,
        active: null,
        enable: null,
        groupid: null,
        usr: null
      },
      roleOptions: {
        0: {
          name: this.$t("role.plantOwner"),
          group: "general"
        },
        2: {
          name: this.$t("role.distributor"),
          group: "admin"
        },
      },
      searchOptions: {
        activeStatus: {
          true: {
            label: this.$t("statistic.active"),
            class: "active"
          },
          false: {
            label: this.$t("statistic.inactive"),
            class: "inactive"
          },
        }, // 活跃状态
        accountStatus: {
          true: {
            label: this.$t("account.enable"),
            class: "active"
          },
          false: {
            label: this.$t("account.disable"),
            class: "inactive"
          },
        }, // 用户状态
        accountGroup: [] // 用户分组
      },
      accountList: [],
      loadingAccount: false,
      loadingeditcount: false,
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      }, // 分页数据
      usrDatas: {
        mobile: "",
        qname: "",
        usr: "",
        email: "",
        role: ""
      }, //编辑账号里面的信息
      groupcountcontent: {
        usr: "",
        id: ""
      }, //分组
      params: "",
      group: [], //放置分组id和名称的盒子
      midgroup: [], //放置分组id和名称的盒子
      options: "",
      vcode: "",
      form: {
        mobile: "",
        qname: "",
        name: "",
        email: "",
        role: "0",
        pwd: "",
        confPwd: ""
      }, //创建新帐号
      resetform: {
        usr: "",
        newpwd: "",
        confPwd: ""
      }, //重置密码
      creatRules: {
        name: [{ required: true, validator: validateusr, trigger: "change" }],
        pwd: [{ required: true, validator: validatepwd, trigger: "change" }],
        confPwd: [
          { required: true, validator: validateconfPwd, trigger: "change" }
        ],
        email: [
          { required: true, validator: validateemail, trigger: "change" }
        ],
        mobile: [
          { required: true, validator: validatephone, trigger: "change" }
        ]
      },
      editRules: {
        email: [
          {
            required: true,
            message: this.$t("message.email_is_required"),
            trigger: "blur"
          },
          {
            pattern: /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)?@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: this.$t("message.email_info"),
            trigger: "blur"
          }
        ],
        mobile: [
          {
            required: true,
            message: this.$t("message.mobile_is_required"),
            trigger: "blur"
          },
          {
            min: 6,
            max: 32,
            message: this.$t("message.length6_32"),
            trigger: "blur"
          }
        ]
      },
      resetRules: {
        usr: [
          {
            required: true,
            message: this.$t("message.uname_is_required"),
            trigger: "blur"
          }
        ],
        newpwd: [{ required: true, validator: validatepwd, trigger: "change" }],
        // 确认密码
        confPwd: [
          { required: true, validator: validateconfNewpwd, trigger: "change" }
        ]
      },
      groupRules: {
          id: [
          {
            required: true,
            message: this.$t("message.id_is_required"),
            trigger: "blur"
          }
        ],
      }
    };
  },
  created() {
    // 解析通过路由传入的搜索条件
    let { role = null, active = null } = this.$route.query;
    this.search.role = role;
    this.search.active = active;

    this.queryAccountGroup();
    this.getAccountList();
    this.getVcode();
  },
  methods: {
    Bytecheck() {
      this.Byte = false;
      this.usrtip = this.$t("message.uname_is_required");
    },
    pwdcheck() {
      this.strength = false;
      this.pwdtip = this.$t("message.pwd_is_required");
    },
    emailcheck() {},
    phonecheck() {},
    UserByte() {
      var usernameRegex = /^([a-zA-Z0-9_\u4e00-\u9fa5]{2,32})$/;
      if (usernameRegex.test(this.form.name)) {
        //用户格式正确的情况下
        this.Byte = true;
        this.Bytes = this.form.name.length;
      } else {
        this.Byte = false;
        // this.usrtip = this.$t('signup.usrformat')
      }
    },
    Passwordlevel() {
      var reg = /^[\w]{6,32}$/i; //判断密码格式是否正确
      var reg1 = /[a-zA-Z]/; //字母
      var reg2 = /\d/; //数字
      var reg3 = /_/; //下划线
      if (reg.test(this.form.pwd)) {
        //密码格式正确的情况下
        if (
          reg1.test(this.form.pwd) &&
          reg2.test(this.form.pwd) &&
          reg3.test(this.form.pwd)
        ) {
          //高级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#3CBD35";
          this.count = this.$t("signup.qiang");
        } else if (
          (reg1.test(this.form.pwd) && reg2.test(this.form.pwd)) ||
          (reg1.test(this.form.pwd) && reg3.test(this.form.pwd)) ||
          (reg2.test(this.form.pwd) && reg3.test(this.form.pwd))
        ) {
          //中级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#FA9D1F";
          this.count = this.$t("signup.zhong");
        } else if (
          reg1.test(this.form.pwd) ||
          reg2.test(this.form.pwd) ||
          reg3.test(this.form.pwd)
        ) {
          //低级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#FF0000";
          this.count = this.$t("signup.di");
        }
      } else {
        this.strength = false;
      }
    },
    NewPasswordlevel() {
      var reg = /^[\w]{6,32}$/i; //判断密码格式是否正确
      var reg1 = /[a-zA-Z]/; //字母
      var reg2 = /\d/; //数字
      var reg3 = /_/; //下划线
      if (reg.test(this.resetform.newpwd)) {
        //密码格式正确的情况下
        if (
          reg1.test(this.resetform.newpwd) &&
          reg2.test(this.resetform.newpwd) &&
          reg3.test(this.resetform.newpwd)
        ) {
          //高级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#3CBD35";
          this.count = this.$t("signup.qiang");
        } else if (
          (reg1.test(this.resetform.newpwd) &&
            reg2.test(this.resetform.newpwd)) ||
          (reg1.test(this.resetform.newpwd) &&
            reg3.test(this.resetform.newpwd)) ||
          (reg2.test(this.resetform.newpwd) && reg3.test(this.resetform.newpwd))
        ) {
          //中级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#FA9D1F";
          this.count = this.$t("signup.zhong");
        } else if (
          reg1.test(this.resetform.newpwd) ||
          reg2.test(this.resetform.newpwd) ||
          reg3.test(this.resetform.newpwd)
        ) {
          //低级密码
          this.strength = true;
          this.$refs.NewPasswordlevel.style.backgroundColor = "#FF0000";
          this.count = this.$t("signup.di");
        }
      } else {
        this.strength = false;
      }
    },
    // 查询用户所有分组
    queryAccountGroup() {
      this.$request.get("queryAccountGroup").then(res => {
        if (res.err === 0) {
          res.dat.group.forEach(item => {
            this.group.push({
              label: item.name,
              value: item.id
            });
          });
          this.searchOptions.accountGroup = this.group;
          // var All = {
          //   "label": this.$t("statistic.All"),
          //   "value": ""
          // }
          // this.searchOptions.accountGroup.push(All)
        }
      });
    },
    // 查询用户列表
    getAccountList(reset) {
      this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      // if(reset == personActive)
      let param = {
        ...this.search,
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize
      };

      this.loadingAccount = true;
      this.$request.get("webQueryUsrEs", param).then(res => {
        if (res.err === 0) {
          res.dat.account.forEach(item => {
            item.role = this.$filter.role(item.role).name;
            item.active = this.searchOptions.activeStatus[item.active];
            item.enable = this.searchOptions.accountStatus[item.enable];
          });
          this.accountList = res.dat.account;
          this.pagination.total = res.dat.total;
          if(this.pagination.total > this.pagination.pagesize){
            this.paginationControl = true
          }
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.emptyText = true;
          this.accountList = [];
          this.pagination.total = 0;
        }

        this.loadingAccount = false;
      });
    },
    //关闭对话框
    closeDialog() {
      this.showCreatnewcountDialog = false;
      this.showEditcountDialog = false;
      this.showdisablecountDialog = false;
      this.showGroupcountDialog = false;
      this.showResetpwdDialog = false;
      this.showDeletecountDialog = false;
    },
    //打开创建账号按钮
    creatcount() {
      this.showCreatnewcountDialog = true;
      this.form = {
        mobile: "",
        qname: "",
        name: "",
        email: "",
        role: "0",
        pwd: "",
        confPwd: ""
      };
      this.confpwdError = false;
      this.isError = false;
      this.emailError = false;
      this.passpwdError = false;
      this.phoneError = false;
      this.Byte = false;
      this.strength = false;
      this.usrtip = null;
      this.pwdtip = null;
      this.emailtip = null;
      this.phonetip = null;
      this.confpwdtip = null;
    },
    //创建账号
    creatnewcount() {
      this.$refs.creatForm.validate(valid => {
        if (!valid) return false;
        this.$request
          .get(this.form.role == 2 ? "addDist" : "addPlantOwner", {
            usr: this.form.name,
            email: this.form.email,
            mobile: this.form.mobile,
            qname: this.form.qname,
            source: 1,
            vcode: this.vcode,
            pwd: encryption.byte2hex(
              encryption.rc4(
                encryption.sha1(this.form.pwd),
                this.$store.state.user.secret
              )
            )
          })
          .then(res => {
            if (res.err == 0) {
              this.$message.success(this.$t("account.createSuc"));
              this.showCreatnewcountDialog = false;
              this.getAccountList();
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
          });
      });
    },
    //获取经销商编码（创建经销商账号时有用）
    getVcode() {
      this.$request.get("queryAccountInfo").then(res => {
        if (res.err == 0) {
          if (res.dat.vendor) {
            this.vcode = res.dat.vendor.vcode.join(",");
          } else if (res.dat.dist) {
            this.vcode = res.dat.dist.vcode.join(",");
          }
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    //打开编辑用户按钮
    editcount(info) {
      this.showEditcountDialog = true;
      this.params = info;
      this.usrDatas = {...info}
      // this.loadingeditcount = true;
      // this.$request.get("webQueryUsrEs", { uid: this.params.uid }).then(res => {
      //   if (res.err == 0) {
      //     (res.dat.account[0].role =
      //       res.dat.account[0].role == "2"
      //         ? this.$t("account.distributor")
      //         : this.$t("account.plantOwner")),
      //       (this.usrDatas = res.dat.account[0]);
      //   } else {
      //     this.$message.error(this.$t(`errCode.${res.err}`));
      //   }
      //   this.loadingeditcount = false;
      // });
    },
    //编辑用户
    editoldcount() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return false;
        this.$request
          .get("editSubAccount", {
            uid: this.params.uid,
            qname: this.usrDatas.qname || ' ',
            mobile: this.usrDatas.mobile,
            email: this.usrDatas.email
          })
          .then(res => {
            if (res.err == 0) {
              this.$message.success(this.$t("account.modifiedsuccess"));
              this.showEditcountDialog = false;
              this.getAccountList();
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
          });
      });
    },
    //打开禁用按钮
    disablecount(info) {
      this.showdisablecountDialog = true;
      this.params = info;
    },
    //禁用账号
    disableoldcount() {
      this.$request
        .get("disableOrEnableAccount", {
          enable:this.params.enable.class == "inactive"? "true": "false",
          uid: this.params.uid
        })
        .then(res => {
          if (res.err == 0) {
            if (this.params.enable.class == "inactive") {
              this.$message.success(this.$t("account.enablesuccess"));
            } else {
              this.$message.success(this.$t("account.disablesuccess"));
            }
            this.showdisablecountDialog = false;
            this.getAccountList();
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //打开分组按钮
    groupcount(info) {
      this.showGroupcountDialog = true;
      this.params = info;
      this.groupcountcontent.usr = info.usr;
      this.groupcountcontent.id = info.groupId;
      this.midgroup = [];
      this.$request.get("queryAccountGroup").then(res => {
        if (res.err === 0) {
          res.dat.group.forEach(item => {
            this.midgroup.push({
              label: item.name,
              value: item.id
            });
          });
          let arr = { label: this.$t("account.deletegroup"), value: "0.0001" };
          this.midgroup.unshift(arr);
          this.options = this.midgroup;
        }
      });
    },
    //向分组中加成员按钮
    addgroupcount() {
       this.$refs.groupform.validate(valid => {
        if (!valid) return false;
      if (this.groupcountcontent.id == "0.0001") {
        this.$request
          .get("delAccountFromGroup", {
            uid: this.params.uid
          })
          .then(res => {
            if (res.err == 0) {
              this.$message.success(this.$t("account.deletegroupsuccess"));
              this.showGroupcountDialog = false;
              this.getAccountList();
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
          });
      } else {
        this.$request
          .get("addAccountToGroup", {
            id: this.groupcountcontent.id,
            uid: this.params.uid
          })
          .then(res => {
            if (res.err == 0) {
              this.$message.success(this.$t("account.groupsuccess"));
              this.showGroupcountDialog = false;
              this.getAccountList();
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
          });
      }
      });
    },
    //打开重置密码按钮
    resetpwd(info) {
      this.showResetpwdDialog = true;
      this.params = info;
      this.resetform.usr = info.usr;
      this.resetform.newpwd = null;
      this.resetform.confPwd = null;

      this.confpwdError = false;
      this.isError = false;
      this.emailError = false;
      this.passpwdError = false;
      this.phoneError = false;
      this.Byte = false;
      this.strength = false;
      this.usrtip = null;
      this.pwdtip = null;
      this.emailtip = null;
      this.phonetip = null;
      this.confpwdtip = null;
    },
    //重置密码
    resetpwdold() {
      this.$refs.resetform.validate(valid => {
        if (!valid) return false;
        this.$request
          .get("resetSubUsrPassword", {
            uid: this.params.uid,
            newpwd: encryption.byte2hex(
              encryption.rc4(
                encryption.sha1(this.resetform.newpwd),
                this.$store.state.user.secret,
                // cookie.getCookie("secret")
              )
            )
          })
          .then(res => {
            if (res.err == 0) {
              this.$message.success(this.$t("account.pwdresetsuccess"));
              this.showResetpwdDialog = false;
              this.getAccountList();
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
          });
      });
    },
    //打开删除按钮
    detelegroup(info) {
      this.showDeletecountDialog = true;
      this.params = info;
    },
    //删除用户按钮
    deleteoldcount() {
      //删除经销商账号
      if (this.params.role == this.$t("account.distributor")) {
        this.$request
          .get("delDist", {
            uid: this.params.uid
          })
          .then(res => {
            if (res.err == 0) {
              this.$message.success(this.$t("account.Deletesuccessfully"));
              this.showDeletecountDialog = false;
              this.getAccountList();
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
          });
      } //删除电站业主账号
      else if (this.params.role == this.$t("account.plantOwner")) {
        this.$request
          .get("delPlantOwner", {
            uid: this.params.uid
          })
          .then(res => {
            if (res.err == 0) {
              this.$message.success(this.$t("account.Deletesuccessfully"));
              this.showDeletecountDialog = false;
              this.getAccountList();
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
          });
      }
    },
    // 点击用户名打开该用户窗口
    enterAccount(info) {
      // 非储能用户不能跳转
      if (info.source != 1) {
        this.$message.error(this.$t("account.cannotRedirect"));
        return;
      }
      this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then(res => {
          if (res.err === 0) {
            let routeUrl = this.$router.resolve({
              path: "/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
              }
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.account {
  background-color: #fff;
  margin: 10px;
  // margin: 24px 24px 50px 24px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  .chuangjian,
  .chongzhi {
    // /deep/ .el-form-item__label {
    //   position: absolute;
    //   left: -22px;
    // }
    // /deep/ .el-form-item {
    //   position: relative;
    //   display: flex;
    //   align-items: center;
    // }
    // /deep/ .el-form-item__content {
    //   line-height: normal;
    //   // height: 40px;
    //   flex: 1;
    // }
    // /deep/ .el-input__prefix {
    //   width: 40px;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    // }
    // /deep/ .el-input__inner {
    //   padding-left: 40px;
    // }
    .juxing {
      display: inline-block;
      width: 100px;
      height: 10px;
      border: 0px solid #fff;
      margin-left: 5px;
    }
    .inputlo {
      margin-bottom: -16px;
      height: 20px;
    }
    .input_spans,
    .pwd_span,
    .email_span,
    .phone_span,
    .confpwd_span {
      height: 20px;
      line-height: 20px;
      color: #f56c6c;
      font-size: 12px;
    }
    .input_span{
      height: 20px;
      line-height: 20px;
    }
    .sucess {
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      color: #999;
      // font-family: "Microsoft YaHei";
    }
    /deep/ .el-form-item__error {
      display: none;
    }
  }
  .bianji {
    // /deep/ .el-form-item__label {
    //   position: absolute;
    //   left: -22px;
    // }
    // /deep/ .el-form-item__content {
    //   line-height: normal;
    //   flex: 1;
    // }
    // /deep/ .el-form-item {
    //   position: relative;
    //   display: flex;
    //   align-items: center;
    // }
    // /deep/ .el-input__prefix {
    //   width: 40px;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    // }
    // /deep/ .el-input__inner {
    //   padding-left: 40px;
    // }
  }
  // .accounttop {
  //   display: flex;
  //   flex-direction: row;
  //   justify-content: space-between;
  //   padding: 15px 24px;
  //   .accountname {
  //      font-size:16px;
  //      font-weight: bold;
  //      color: #333;
  //      letter-spacing: 1.5px;
  //   }
  // }
  .button-create {
      float: right;
    }
  .sections {
    margin: 0 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow:hidden;
    .table {
      flex: 1;
      // overflow: hidden;
      overflow: auto;
      /deep/ .el-icon-loading{
            font-size: 28px;
        }
    }
    .tablebottom {
      // text-align: center;
      align-self: flex-end;
      margin-bottom: 10px;
    }
  }
  .active {
    color: #26ae3c;
  }
  .inactive {
    color: #c9c9c9;
  }
}
// .disablecontent {
//   display: flex;
//   justify-content: center;
//   font-size: 20px;
//   font-weight: 600;
// }
// .disabledescr {
//   display: flex;
//   justify-content: center;
//   margin-top: 10px;
//   font-size: 10px;
// }
</style>
